export enum Condition {
  Warn = "Warn",
  // Error = "Error",
  // Success = "Success",
}
